import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { FilterModal } from './filterModal.component';
import {
  FiltersActions,
  selectCurrentFilter,
  selectCurrentFilterName,
  selectIsModalVisible,
} from '../../../modules/filters';

const mapStateToProps = createStructuredSelector({
  currentFilterName: selectCurrentFilterName,
  currentFilter: selectCurrentFilter,
  isModalVisible: selectIsModalVisible,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      hideModal: FiltersActions.hideModal,
      setFilterDataByFilterName: FiltersActions.setFilterDataByFilterName,
      animateModalByFilterName: FiltersActions.animateModalByFilterName,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(FilterModal);
